'use memo';

import { createFileRoute } from '@tanstack/react-router';
import Icon from '@/components/Icon/Icon';
import { Text } from '@/components/Typography';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { CATEGORIES, CATEGORY_OWNER_PRODUCTS, type CategoryTranslationKey } from '../-constants';
import { useAllowIndividualRequestOperationPackagesQueries } from '../-query/useAllowIndividualRequestOperationPackagesQuery';
import { RequestsListCard, type RequestCategoryGroup } from './-components/RequestsListCard';
export const Route = createFileRoute('/_individual/individual/request/')({
  component: RequestPage
});
function EmptyState() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.request.emptyState'
  });
  return <div className="flex flex-col items-center justify-center gap-2 py-10 text-center">
      <Icon iconName="FolderOpenIcon" className="h-8 w-8 text-neutral-muted-on-fill" />
      <Text variant="label">{t('title')}</Text>
      <Text variant="pSmall" className="text-neutral-muted-on-fill">
        {t('description')}
      </Text>
    </div>;
}
function RequestPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.request.categories'
  });
  const results = useAllowIndividualRequestOperationPackagesQueries(CATEGORY_OWNER_PRODUCTS);
  const allEmpty = results.every(result => result.data.length === 0);
  const categoryLabels: Record<CategoryTranslationKey, string> = {
    contractorCore: t('contractorCore'),
    gaOperationCore: t('gaOperationCore'),
    itOperationCore: t('itOperationCore'),
    laborCore: t('laborCore')
  };
  const groups: RequestCategoryGroup[] = CATEGORIES.map((category, index) => ({
    LogoComponent: category.logo,
    id: category.id,
    label: categoryLabels[category.translationKey],
    packages: results[index].data.map(pkg => ({
      name: pkg.name,
      operationPackageId: pkg.operationPackageId
    }))
  })).filter(group => group.packages.length > 0);
  return <div className="mx-auto max-w-[1280px] px-4 py-6 md:px-[100px] md:py-10">
      <div className="mx-auto flex w-full max-w-[800px] flex-col gap-9">
        {/* TODO: 検索機能は未配線のため一旦無効化。配線時に RequestSearchBar を復活させる */}
        {allEmpty ? <EmptyState /> : <RequestsListCard groups={groups} />}
      </div>
    </div>;
}